// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD3g5HPyEo2RrV4yI7j_F54hQj56cXdiMM",
  authDomain: "mn-portfolio.firebaseapp.com",
  projectId: "mn-portfolio",
  storageBucket: "mn-portfolio.appspot.com",
  messagingSenderId: "79164733586",
  appId: "1:79164733586:web:4924676248ba65e993ce4b",
  measurementId: "G-X8ZBTD3CGP"
};

// Initialize Firebase
initializeApp(firebaseConfig)

const db = getFirestore()
export default db